import { Http } from "../../utils/types";
import { DeleteServiceLevelPayload, ServiceLevelBodyPayload, ServiceLevelByIdPayload, ServiceLevelListPayload, ServiceLevelUpdateBodyPayload } from "./body";
import { CreateResponse, DeleteServiceLevel } from "./response";
import { transformById, transformList } from "./trasform";

export const levelService = (client: Http) => ({
    createServiceLevel: async ({ body }: ServiceLevelBodyPayload): Promise<CreateResponse> => client.post('time-service/config', body),
    updateServiceLevel: async ({ body, id }: ServiceLevelUpdateBodyPayload): Promise<CreateResponse> => client.put(`time-service/config/${id}`, body),
    getServiceLevel: async ({ query }: ServiceLevelListPayload) => {
        const response = await client.get(`time-service/config/detailed${query ? '?' + query : ''}`)
        const data = transformList({ response })
        return data
    },
    deleteServiceLeve: async ({ id }: DeleteServiceLevelPayload): Promise<DeleteServiceLevel> => await client.delete(`time-service/config/${id}`),
    getServiceLevelById: async ({ id }: ServiceLevelByIdPayload) => {
        const response = await client.get(`time-service/config/${id}`)
        const data = transformById({ response })
        return data
    }
})